import React from 'react'

import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import DeleteButton from '../common/buttons/DeleteButton'
import DataTableComp from '../common/data-table/DataTableComp'
import { DataTableFun } from '../../utils/helpers/dataTableFun'

const DataTableAccountSalaryConcepts = ({
  data,
  loading = false,
  showHeaders = true,
  showWhenNoData = false,
  handleDelete,
}) => {
  const { formatMessage: msg } = useIntl()

  const buttonDelete = (rowData) => {
    return (
      <DeleteButton
        isDisabled={loading}
        onClick={() => handleDelete(rowData)}
      />
    )
  }

  const columns = () => {
    const commonColumns = [
      <Column
        field="conceptCode"
        sortable={data?.length > 1}
        style={{ width: '60%' }}
        body={(rowData) =>
          String(rowData.conceptCode || '')
            .concat(' ')
            .concat(String(rowData.conceptName || ''))
        }
        header={showHeaders && msg({ id: 'salaryConcept' })}
      />,
      <Column
        field="isAdd"
        sortable={data?.length > 1}
        style={{ width: '30%' }}
        align="right"
        body={(rowData) =>
          rowData?.isAdd ? msg({ id: 'addition' }) : msg({ id: 'subtraction' })
        }
      />,
    ]

    return handleDelete
      ? [
          ...commonColumns,
          <Column field="_id" body={(rowData) => buttonDelete(rowData)} />,
        ]
      : commonColumns
  }

  return (data && data.length > 0) || showWhenNoData ? (
    <DataTableComp
      style={{ width: '100%' }}
      disableAutoheight={true}
      tableOptions={{
        showHeaders,
        value: data,
        responsiveLayout: 'scroll',
        scrollable: false,
        // scrollHeight: DataTableFun.responsiveHeight(),
      }}
      autoColumnKey
      columns={columns()}
    />
  ) : null
}

export default DataTableAccountSalaryConcepts
